import type { TradeIntent } from '../ValueDashboard/GameDetailPanel';
import type { GameRow } from '../ValueDashboard/types';
import { venueSlot } from '@/lib/venue/venueSlot';

/** Key reshaping may find a row, but only execution identity may adopt it.
 * A missing live book never licenses the click-time price snapshot. */
export function exactLiveCardGame(
  candidate: GameRow | null | undefined,
  snapshot: GameRow,
  intent: TradeIntent,
): GameRow | null {
  if (!candidate) return null;
  // venueSlot, not an index: the third venue's slot is `polymarketUs`, not its wire name.
  const before = venueSlot(snapshot, intent.venue)?.[intent.side];
  const after = venueSlot(candidate, intent.venue)?.[intent.side];
  if (!before || !after) return null;
  if (Boolean(before.nativeSideInverted) !== Boolean(after.nativeSideInverted)) return null;
  if (intent.venue === 'kalshi') {
    return before.marketTicker && after.marketTicker === before.marketTicker ? candidate : null;
  }
  // Both outcome tokens constrain the book because its YES/NO toggle remains
  // available. A missing token cannot certify an executable replacement.
  if (!before.tokenId && !before.noTokenId) return null;
  for (const field of ['tokenId', 'noTokenId', 'conditionId'] as const) {
    if (before[field] && before[field] !== after[field]) return null;
  }
  return candidate;
}
